export default {
  blogList: [],
  blogListLoading: false,
  blogListLoaded: false,
  blogData: {},
  blogDataLoading: false,
};
